import React from 'react';
import { cn } from '../../../lib/cn';

export interface DashboardSectionHeadProps {
  index?: string;
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  accentColor?: string;
  className?: string;
  /** Reference mature section header uses surface-mute background */
  variant?: 'default' | 'mature';
}

export function DashboardSectionHead({
  index,
  title,
  subtitle,
  action,
  accentColor,
  className,
  variant = 'default',
}: DashboardSectionHeadProps) {
  const mature = variant === 'mature';

  return (
    <header
      className={cn(
        'relative flex items-start gap-4 border-b border-[var(--cream-2)]',
        mature ? 'bg-[var(--surface-mute)] px-5 py-3.5' : 'bg-[var(--cream-1)] px-5 py-3.5',
        className,
      )}
    >
      {accentColor ? (
        <span className="absolute bottom-0 left-0 top-0 w-0.5" style={{ background: accentColor }} />
      ) : null}
      <div className="min-w-0 flex-1">
        <div className={cn('flex items-center gap-2.5', subtitle ? (mature ? 'mb-[3px]' : 'mb-0.5') : '')}>
          {index ? (
            <span
              className={cn(
                'rounded border border-[var(--cream-2)] px-[5px] py-0.5 font-[var(--font-mono)] text-[10px] font-semibold tracking-[0.1em] text-[var(--ink-3)]',
                mature ? 'bg-[var(--cream-1)]' : 'bg-[var(--cream-0)]',
              )}
            >
              {index}
            </span>
          ) : null}
          <h2 className="m-0 font-[var(--font-display)] text-[15px] font-bold leading-tight tracking-[-0.02em] text-[var(--ink-0)]">
            {title}
          </h2>
        </div>
        {subtitle ? (
          <p
            className={cn(
              'm-0 max-w-[70ch] text-[11.5px] leading-[1.45] tracking-[-0.005em] text-[var(--ink-2)]',
              index ? 'ml-7' : '',
            )}
          >
            {subtitle}
          </p>
        ) : null}
      </div>
      {action ? <div className="flex shrink-0 items-center gap-2">{action}</div> : null}
    </header>
  );
}
